import { TFunction } from 'i18next';
import { SsoIntegrationStatusEnum } from 'graphql-common';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';

type Args = {
  onActivate: () => void;
  onDeactivate: () => void;
  onDelete: () => void;
  status?: SsoIntegrationStatusEnum;
  t: TFunction<'translation', undefined>;
};

export default function getSsoViewPageActionsMenu({
  onActivate,
  onDeactivate,
  onDelete,
  status,
  t,
}: Args): NavItem<undefined>[] {
  return [
    {
      id: 'activate-action',
      title: t('activate'),
      onClick: () => onActivate(),
      leftIcon: Icons.activate,
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: () => status !== SsoIntegrationStatusEnum.Active,
    },
    {
      id: 'deactivate-action',
      title: t('deactivate'),
      onClick: () => onDeactivate(),
      leftIcon: Icons.deactivate,
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: () => status === SsoIntegrationStatusEnum.Active,
    },
    {
      id: 'delete-action',
      title: t('delete'),
      onClick: () => onDelete(),
      leftIcon: Icons.delete,
      type: NavItemTypeEnum.Secondary,
    },
  ];
}
